import request from '@/plugins/axios'


//删除人物
export function deletePeople(params) {
  return request({
    url: '/people/deletePeople/' + params,
    method: 'get'
  })
}

//创建人物
export function addPeople(data) {
  return request({
    url: '/people/addPeople',
    method: 'post',
    data
  })
}

//获取人物常量
export function getPeopleConstant() {
  return request({
    url: '/people/getPeopleConstant',
    method: 'get'
  })
}

//获取人物列表
export function listPeople(params) {
  return request({
      url: '/people/listPeople',
      method: 'get',
      params
  })
}

//忽略人物/取消忽略
export function setPass(params) {
  return request({
      url: '/people/setPass',
      method: 'get',
      params
  })
}

//标记人物
export function markPeople(params) {
  return request({
      url: '/people/markPeople',
      method: 'post',
      params
  })
}

//合并人物
export function mergePeople(params) {
  return request({
      url: '/people/mergePeople',
      method: 'post',
      params
  })
}